<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="500px" @close="close()">
    <div slot="content">
      <el-form :model="ruleData" label-position="top" ref="ruleForm" :rules="formRules">
        <el-row>
          <el-form-item label="정책 이름" prop="syslogRuleName">
            <el-input v-model="ruleData.syslogRuleName" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="정책 설명">
            <el-input type="textarea" :rows="3" v-model="ruleData.syslogRuleDesc" resize="none" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="메시지 필터링">
            <el-input v-model="ruleData.filterCondition" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="예외 메시지 필터링">
            <el-input v-model="ruleData.exceptFilterCondition" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="필터링 등급">
            <el-checkbox-group v-model="ruleData.severity">
              <el-row type="flex" justify="space-between">
                <el-col :span="6">
                  <el-checkbox label="0">Emergency</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="1">Alert</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="2">Critical</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="3">Error</el-checkbox>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="6">
                  <el-checkbox label="4">Warning</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="5">Notice</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="6">Information</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-checkbox label="7">Debug</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtils from '@/utils/message';
import syslogSettingAPI from '@/api/settings/log/syslog-settings';
import { mapGetters } from 'vuex';
import { isEmpty, cloneDeep } from 'lodash';
import WEventlevelCell from '@/components/table/EventlevelCell';

export default {
  name: 'WSyslogRuleSettingPopup',
  components: {
    WEventlevelCell,
  },
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    const formRules = {
      syslogRuleName: [
        { required: true, message: '필수 정보입니다.', trigger: 'blur' },
      ],
    };
    return {
      formRules,
      ruleData: {
        syslogRuleName: '',
        clearRuleFlag: '0',
        syslogRuleDesc: null,
        filterCondition: null,
        exceptFilterCondition: null,
        severity: [],
      },
    };
  },
  computed: mapGetters(['eventlevelInfo']),
  watch: {
    data: {
      immediate: true,
      handler() {
        if (this.title === '정책 수정') {
          this.initialization();
        }
      },
    },
  },
  methods: {
    /**
     * ruleData에 초기값을 Setting한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    initialization() {
      if (!isEmpty(this.data)) {
        if (!isEmpty(this.data.severityGroup)) {
          const severity = this.data.severityGroup.split(',');
          this.data.severity = severity;
        } else {
          this.data.severity = [];
        }
        this.ruleData = cloneDeep(this.data);
      }
    },
    /**
     * 저장 버튼을 눌렀을 때 Validation 체크 후 정책 수정/추가하는 API실행
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      // FIXME Validation 수정 필요
      this.$refs.ruleForm.validate().then((success) => {
        if (success) {
          // 정책 추가일 때와 수정일 때 사용하는 API를 분리
          if (this.title === '정책 수정') {
            syslogSettingAPI.updateSyslogRule(this.ruleData).then((response) => {
              if (response.data.success) {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', response.data.success));
                this.$emit('load-data');
                this.clickClose();
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', false));
              throw new Error(e);
            });
          } else {
            syslogSettingAPI.insertSyslogRule(this.ruleData).then((response) => {
              if (response.data.success) {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', response.data.success));
                this.$emit('load-data');
                this.clickClose();
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', false));
              throw new Error(e);
            });
          }
        }
      }).catch(() => {});
    },
    open() {
      this.$refs.slidingPopup.open();
    },
    close() {
      this.ruleData = {
        syslogRuleName: '',
        clearRuleFlag: '0',
        syslogRuleDesc: null,
        filterCondition: null,
        exceptFilterCondition: null,
        severity: [],
      };
      // validation 초기화
      const clear = ['syslogRuleName'];
      this.$refs.ruleForm.clearValidate(clear);
      this.$emit('delete-selected-row');
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Syslog/popup/SyslogRuleSettingPopup.vue